<template>
  <div class="MyRes fs20">
    <div class="detail">
      <div class="note fs18">
        <div class="reward-image" v-if="passed">
          <canvas id="canvas" style="width: 50vw;" />
        </div>
        <div class="center" v-else>很抱歉您未获奖</div>
        <div class="content paper-tips" v-if="passed">
          获取盖章纸质证书、奖杯（奖牌），请<a target="_blank" href="https://appKGNJyWGE8466.h5.xiaoeknow.com/v1/goods/goods_detail/SPU_ENT_1643334906eXMAeJm99dv1B"> 点击链接</a>或扫描二维码购买并填写地址，节后邮寄。
          <img :src="ShoppingImg" />
        </div>
        <div v-if="reward < 4" class="bold reward-content">
          奖品：
        </div>
        <div class="content reward-content" >
          进阶学习<a target="_blank" href="https://vvf.h5.xeknow.com/s/ptVI2">信息学CSP课程（C++）</a>，获奖选手获得课程代金券： 一等奖：1000-2000元（金银铜金额不同），二等奖：800元，三等奖： 500元。具体请咨询右下角客服。
          <!-- <div class="reward" v-html="rewardContent[reward].main"></div>
               <div class="reward-plus" v-for="p in rewardContent[reward].plus" v-html="p"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import Certify from '@/components/score/Certify.vue'
 import MyImage from '@/components/Image.vue'
 import RewardImg from '@/assets/image/score/final-reward.jpg'
 import ShoppingImg from '@/assets/image/score/shop.png'
 import qrImg from '@/assets/image/score/service_qr.png'

 export default {
   name: 'Final',
   props: [],
   computed: {
     qr () {
       return qrImg
     },
     RewardImg () {
       return RewardImg
     },
     ShoppingImg () {
       return ShoppingImg
     },
     game_year() {
       return this.$store.state.game_slug.slice(0, 4)
     },
     passed () {
       return this.$store.state.auth.game_state[this.game_year+'-3'].state > 0
     },
     user() {
       return this.$store.state.auth.user;
     },
     group() {
       return ['小学组', '初中组', '大学组']
     },
     info() {
       return {
         '姓名': this.user.realname,
         '身份证号': this.user.idcard,
         '地区': this.user.area,
         '组别': this.group[this.user.group-1],
         '参赛单位': this.user.organization? this.user.organization: '个人报名'
       }
     },
     title() {
       return {
         'success': '恭喜你已成功晋级全国决赛',
         'failed':'很遗憾你没有晋级全国决赛'
       }
     },
     reward() {
       return this.$store.state.auth.game_state[this.game_year+'-3'].state
     },
     rewardMap() {
       return ['未参赛', '金牌','银牌','铜牌', '一等奖', '二等奖', '三等奖', '优秀奖'];
     },
     rewardChinese() {
       return ['', '全国一等奖 金牌','全国一等奖 银牌','全国一等奖 铜牌','全国一等奖', '全国二等奖', '全国三等奖', '优秀奖'];
     },
     rewardTips() {
       return ['','','','', '（全国排名前0.65%）', '（全国排名前1.24%）', '（全国排名前8.02%）', '']
     },
     rewardContent() {
       return [
         {},
         {
           main: '<span class="bold">一等奖：</span><span class="red">2000元</span>奖学金课程券，其中含有<span class="red">500元</span>许可证代金券，该许可证可以在6个月内免费学习扣哒世界或奥佳睿编程关卡，以及<span class="red">1500元</span>优质课程代金券，可以任选下面两门进阶课程中的一门，并可拿到相应的课程结业证书。',
           plus: [
             '<span class="red">+499元</span>（原价1999元）C++零基础课程及结业证书（清北名师授课）',
             '<span class="red">+699元</span> （原价2199元）Python高级算法课程及结业证书（清北名师授课）'
           ]
         },
         {
           main: '<span class="bold">二等奖：</span><span class="red">1000元</span>奖学金课程券，其中含有<span class="red">300元</span>许可证代金券，该许可证可以在3个月内学习扣哒世界或奥佳睿编程关卡，以及<span class="red">700元</span>优质课程代金券，可以任选下面两门进阶课程中的一门，并可拿到相应的课程结业证书。',
           plus: [
             '<span class="red">+599元</span> （原价1299元）项目式学习课程及结业证书（清北名师授课）',
             '<span class="red">+799元</span> （原价1499元）Python中级课程及结业证书（清北名师授课）'
           ]
         },
         {
           main: '<span class="bold">三等奖：</span><span class="red">500元</span>奖学金课程券，其中含有<span class="red">100元</span>许可证代金券，该许可证可以在1个月学习扣哒世界或奥佳睿编程关卡，以及<span class="red">400元</span>优质课程代金券，可以任选下面两门进阶课程中的一门，并可拿到相应的课程结业证书。',
           plus: [
             '<span class="red">+799元</span> （原价1199元）项目式学习课程及结业证书（清北名师授课）',
             '<span class="red">+999元</span> （原价1399元） AI世青赛提升课程及结业证书（清北名师授课）'
           ]
         }
       ]
     },
     certificateUrl(){
       let redirect = `/certificates/${this.user.coco_id}?class=5d74782a64cd560026a803ab&course=560f1a9f22961295f9427742&course-instance=5d747ea564cd560026a80438`
       // let redirect = `/certificates/${this.user.coco_id}?class=5cb703db3546da005974ea29&course=560f1a9f22961295f9427742&course-instance=5cb703dbb42c5c004687cf29`
       // console.log("redirect", redirect)
       let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
       return url
     },
     ifPassedLevel(){
       return this.passed ? '你可以登陆至本次大赛竞赛平台领取你的美国大学理事会认证的' : '你可以继续完成竞技场前18个初赛学习关卡即可获得美国大学理事会认证的'
     },
   },
   data() {
     return {
       time: '11月20日',
       /* QQ: 'QQ群：926470859', */
       /* reward: "计算机科学1级（CS1）证书" */
     }
   },
   methods: {
     async download() {
       let can = document.getElementById("canvas")
       let blob = await new Promise(resolve=>can.toBlob(resolve));
       let url = URL.createObjectURL(blob);
       let a = document.createElement('a');
       a.href = url;
       a.download = '证书.png';
       a.click();
     },
     calcSN(id) {
       return 'AI2020' + (50806+id);
     }
   },
   components:{
     certify: Certify,
     my_image: MyImage
   },
   mounted()
   {
     // this.passed = !this.passed;
     let that = this;
     if(!this.passed) return;
     let canvas = document.getElementById('canvas');
     let ctx = canvas.getContext('2d');
     let img = new Image();
     img.src = this.RewardImg;
     img.onload = () => {
       let reward = that.reward;
       canvas.height = img.height;
       canvas.width = img.width;
       ctx.drawImage(img, 0, 0);
       ctx.font = "bolder 28pt simsun";
       ctx.fillStyle = "#dda06d";
       let len = this.user.name.length
       let posx = 110 + (180 - len*40)/2
       ctx.fillText(this.user.name, posx,173);
       ctx.font = "14pt Verdana";
       /* ctx.fillText(this.calcSN(this.user.id), 920, 116); */
       ctx.font = '900 46pt nsimsun';
       ctx.fillStyle = '#d0a06f';
       len = this.rewardChinese[reward].length;
       posx = 500 - len*25;
       ctx.fillText(this.rewardChinese[reward], posx, 420)
       ctx.font= '22pt Arial';
       ctx.fillStyle = '#b48560'
       ctx.fillText(this.rewardTips[reward], 380, 465)
     }
     /* let seal = new Image();
      * seal.src = this.sealImg;
      *       seal.onload = () => {
      *         ctx.drawImage(seal, 800, 540);
      *       }
      *     }) */
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .download{
   cursor: pointer;
 }
 .MyRes, .detail{
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content:center;
   position: relative;
   margin-bottom: 2vw;
 }
 .success, .failed{
   color: white;
   background-size: 60vw;
   width: 60vw;
   height: 10vw;
   display:flex;
   justify-content:center;
   align-items:center;
   font-size: 2.3vw;
 }
 .success{
   background-image: url(~@/assets/image/score/success.png);
 }
 .failed{
   background-image: url(~@/assets/image/score/failed.png);
 }
 .info{
   background-image: url(~@/assets/image/score/bg-myinfo.png);
   background-size: 62.3vw;
   width: 62.3vw;
   height: 10.78vw;
   color: white;

   margin-top:4vw;
   box-sizing: border-box;
   padding-left: 4.375vw;
   padding-right: 5.4vw;
   padding-top:1.15vw;
   padding-bottom: 3.125vw;
   display: flex;
 }
 .column{
   flex-grow: 1;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
   border-right: solid 1px #7ec5ff;
 }
 .column:last-child{
   border-right: none !important;
 }
 .column>div{
   height: 3.25vw;
   display:flex;
   justify-content:center;
   align-items:center;
 }
 .first_line{
   border-bottom: solid 1px #7EC5FF;
   width: 100%;
 }
 .certify{
   position: absolute;
   background-color: rgb(255, 255, 255);
   border-radius: 5px;
   box-sizing: border-box;
   padding: 6.3vw 5vw 1vw 2.6vw;
   box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
   height: 100%;
 }
 .note .content span{
   color:#FE2121;
 }
 .note .name{
   color: #2F2E38;
   font-weight: 600;
 }
 .note .content.paper-tips{
   display: flex;
   flex-direction: column;
   font-size: 22px;
   align-items: center;
   width: 50vw;
   margin-top: 20px;
 }
 .note .badging{
   color: #585668;
   align-self: flex-end;
 }
 .note{
   display: flex;
   flex-direction: column;
   align-items:flex-start;
   width: 46vw;
 }
 .reward-image{
   margin-top: 3vw;
   display:flex;
   align-items:center;
   flex-direction: column;
   color: #405aee;
 }
 .reward-content{
   font-size: 16px;
   margin-top: 40px;
 }

 .important{
   font-weight: bold;
   color: #405aee;
   display: flex;
   align-items: center;
   margin-top: 1em;
   flex-direction: column;
 }
 .content{
   text-indent: 2em;
 }
 .reward-plus{
   text-indent: 3em;
 }

 .content p{
   text-indent: 1em;
 }

 .reward-tips{
   margin-top: 10px;
 }
 .font14{
   font-size: 18px;
 }
  .center{
    font-size: 24px;
    margin:auto;
    margin-top: 50px;
    margin-bottom: 200px;
  }
</style>

<style>

 .bold{
   font-weight: bold;
 }
 .red{
   color: red;
 }
</style>
